// API Configuration
const API_BASE_URL = 'https://api.seelakariagro.com';

// Helper function for API calls
async function apiCall(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const response = await fetch(url, {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

    if (!response.ok) {
        throw new Error(`API Error: ${response.statusText}`);
    }

    return response.json();
}

// Categories
export const getCategories = async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.all) {
        params.append('all', 'true');
    }
    const query = params.toString() ? `?${params.toString()}` : '';
    return apiCall(`/api/categories${query}`);
};

export const createCategory = async (categoryData) => {
    return apiCall('/api/categories', {
        method: 'POST',
        body: JSON.stringify(categoryData),
    });
};

export const updateCategory = async (categoryId, categoryData) => {
    return apiCall(`/api/categories/${categoryId}`, {
        method: 'PUT',
        body: JSON.stringify(categoryData),
    });
};

export const deleteCategory = async (categoryId) => {
    return apiCall(`/api/categories/${categoryId}`, {
        method: 'DELETE',
    });
};

// Products
export const getProducts = async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.category && filters.category !== 'all') {
        params.append('category', filters.category);
    }
    if (filters.search) {
        params.append('search', filters.search);
    }
    if (filters.all) {
        params.append('all', 'true');
    }

    const query = params.toString() ? `?${params.toString()}` : '';
    return apiCall(`/api/products${query}`);
};

export const getProductBySlug = async (slug) => {
    return apiCall(`/api/products/${slug}`);
};

// Orders
export const createOrder = async (orderData) => {
    return apiCall('/api/orders', {
        method: 'POST',
        body: JSON.stringify(orderData),
    });
};

export const getOrders = async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) {
        params.append('status', filters.status);
    }

    const query = params.toString() ? `?${params.toString()}` : '';
    return apiCall(`/api/orders${query}`);
};

export const updateOrderStatus = async (orderId, status) => {
    return apiCall(`/api/orders/${orderId}/status`, {
        method: 'PUT',
        body: JSON.stringify({ status }),
    });
};

// Admin - Products
export const createProduct = async (productData) => {
    return apiCall('/api/products', {
        method: 'POST',
        body: JSON.stringify(productData),
    });
};

export const updateProduct = async (productId, productData) => {
    return apiCall(`/api/products/${productId}`, {
        method: 'PUT',
        body: JSON.stringify(productData),
    });
};

export const deleteProduct = async (productId) => {
    return apiCall(`/api/products/${productId}`, {
        method: 'DELETE',
    });
};

// Admin - Statistics
export const getAdminStats = async () => {
    return apiCall('/api/admin/stats');
};

// WhatsApp Integration
export const sendWhatsAppOrder = (orderData) => {
    const { orderNumber, customerName, customerPhone, items, totalAmount } = orderData;

    let message = `🛒 *New Order from Seelakari Agro*\n\n`;
    message += `📋 Order #: ${orderNumber}\n`;
    message += `📅 Date: ${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}\n\n`;
    message += `👤 *Customer Details*\n`;
    message += `Name: ${customerName}\n`;
    message += `Phone: ${customerPhone}\n`;
    if (orderData.customerEmail) message += `Email: ${orderData.customerEmail}\n`;
    if (orderData.customerAddress) message += `Address: ${orderData.customerAddress}\n`;
    message += `\n🛍️ *Order Items*\n`;

    items.forEach((item, index) => {
        message += `${index + 1}. ${item.name} × ${item.quantity} - ₹${(item.price * item.quantity).toLocaleString('en-IN')}\n`;
    });

    message += `\n💰 *Total Amount: ₹${totalAmount.toLocaleString('en-IN')}*\n\n`;
    message += `---\nPlease confirm this order by replying to this message.`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappNumber = '916382799541';
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

    return whatsappUrl;
};
